function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useRef, useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { DropableContainer, Dropdown, DropdownList, DropdownListContainer, DynamicPortal, KEYBOARD_KEYS } from '@keen.io/ui-core';
import { useDynamicContentPosition, useKeypress } from '@keen.io/react-hooks';
import { AvailableIcons } from '../../../../../../constants';
import Label from '../../../../../Label';
import Row from '../../../../../Row';
import { DropdownWrapper, DropableContainerWrapper } from './IconType.styles';

var IconType = function IconType(_ref) {
  var onChange = _ref.onChange,
      iconType = _ref.iconType;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      dropdownOpen = _useState2[0],
      setDropdownOpen = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectionIndex = _useState4[0],
      setIndex = _useState4[1];

  var IconTypeOptions = AvailableIcons.map(function (icon) {
    return {
      label: icon.charAt(0).toUpperCase() + icon.slice(1),
      value: icon
    };
  });
  var selectedIcon = AvailableIcons.includes(iconType) ? IconTypeOptions.find(function (icon) {
    return icon.value === iconType;
  }) : IconTypeOptions[0];
  var containerRef = useRef(null);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useDynamicContentPos = useDynamicContentPosition(containerRef),
      setPosition = _useDynamicContentPos.setPosition,
      contentPosition = _useDynamicContentPos.contentPosition;

  useEffect(function () {
    if (dropdownOpen) {
      var iconIndex = IconTypeOptions.findIndex(function (_ref2) {
        var value = _ref2.value;
        return value === iconType;
      });
      var index = iconIndex > 0 ? iconIndex : 0;
      setIndex(index);
    }

    return function () {
      setIndex(null);
    };
  }, [dropdownOpen]);
  var keyboardHandler = useCallback(function (_e, keyCode) {
    switch (keyCode) {
      case KEYBOARD_KEYS.ENTER:
        var value = IconTypeOptions[selectionIndex].value;
        onChange(value);
        setDropdownOpen(false);
        break;

      case KEYBOARD_KEYS.UP:
        if (selectionIndex > 0) {
          setIndex(selectionIndex - 1);
        }

        break;

      case KEYBOARD_KEYS.DOWN:
        if (selectionIndex === null) {
          setIndex(0);
        } else if (selectionIndex < IconTypeOptions.length - 1) {
          setIndex(selectionIndex + 1);
        }

        break;

      case KEYBOARD_KEYS.ESCAPE:
        setDropdownOpen(false);
        break;
    }
  }, [selectionIndex, IconTypeOptions]);
  useKeypress({
    keyboardAction: keyboardHandler,
    handledKeys: [KEYBOARD_KEYS.ENTER, KEYBOARD_KEYS.ESCAPE, KEYBOARD_KEYS.UP, KEYBOARD_KEYS.DOWN],
    addEventListenerCondition: dropdownOpen,
    eventListenerDependencies: [dropdownOpen, selectionIndex, IconTypeOptions]
  });
  return React.createElement("div", null, React.createElement(Row, null, React.createElement(Label, null, t('widget_customization_metric_settings.icon')), React.createElement(DropableContainerWrapper, {
    ref: containerRef
  }, React.createElement(DropableContainer, {
    variant: "secondary",
    onClick: function onClick() {
      setPosition();
      setDropdownOpen(!dropdownOpen);
    },
    isActive: dropdownOpen,
    value: selectedIcon.value,
    dropIndicator: true,
    onDefocus: function onDefocus() {
      return setDropdownOpen(false);
    }
  }, selectedIcon.label)), React.createElement(DynamicPortal, null, React.createElement(DropdownWrapper, {
    x: contentPosition.x,
    y: contentPosition.y
  }, React.createElement(Dropdown, {
    isOpen: dropdownOpen
  }, React.createElement(DropdownListContainer, {
    scrollToActive: true,
    maxHeight: 150
  }, function (activeItemRef) {
    return React.createElement(DropdownList, {
      ref: activeItemRef,
      items: IconTypeOptions,
      setActiveItem: function setActiveItem(_ref3) {
        var value = _ref3.value;
        return IconTypeOptions[selectionIndex] && value === IconTypeOptions[selectionIndex].value;
      },
      onClick: function onClick(_e, icon) {
        return onChange(icon.value);
      }
    });
  }))))));
};

export default IconType;